import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import Login from './pages/auth/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/home/Home';
import ProcessDiagram from './pages/city/ProcessDiagram';
import ProcessFlow from './pages/city/ProcessFlow';
import ManualUpload from './pages/city/ManualUpload';
import VideoMonitor from './pages/city/VideoMonitor';
import YingshanBoard from './views/YingshanBoard';
import YingshanPortal from './views/YingshanPortal';
import { REQUIRE_VISITOR_LOGIN } from './config/auth';
import { logPageVisit } from './utils/apiClient';
import { isLoggedIn } from './utils/session';
import './App.css';

function LegacyProcessFlowRedirect() {
  const { city } = useParams();
  return <Navigate to={`/city/${city}/process-flow`} replace />;
}

function VisitLogger() {
  const location = useLocation();
  useEffect(() => {
    if (REQUIRE_VISITOR_LOGIN && !isLoggedIn()) return;
    if (location.pathname === '/login') return;
    logPageVisit(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <VisitLogger />
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={REQUIRE_VISITOR_LOGIN ? <Login /> : <Navigate to="/home" replace />}
          />
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/city/:city/process-diagram" element={<ProtectedRoute><ProcessDiagram /></ProtectedRoute>} />
          <Route path="/city/:city/process-flow" element={<ProtectedRoute><ProcessFlow /></ProtectedRoute>} />
          <Route path="/city/:city/process" element={<LegacyProcessFlowRedirect />} />
          <Route path="/city/:city/manual-upload" element={<ProtectedRoute><ManualUpload /></ProtectedRoute>} />
          <Route path="/city/:city/video" element={<ProtectedRoute><VideoMonitor /></ProtectedRoute>} />
          <Route path="/yingshan-board" element={<ProtectedRoute><YingshanBoard /></ProtectedRoute>} />
          <Route path="/yingshan-portal" element={<ProtectedRoute><YingshanPortal /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
